const setLatlon = (payload) => {
    return {
        type: "addHouseLatLonChange",
        payload
    }
};

export default setLatlon;